import _assertThisInitialized from "/home/runner/work/w3/w3/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _classCallCheck from "/home/runner/work/w3/w3/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/w3/w3/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/w3/w3/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/w3/w3/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/w3/w3/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/w3/w3/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { timestampWithMs, logger } from '@sentry/utils';
import { SpanRecorder } from './span.js';
import { Transaction } from './transaction.js';
var DEFAULT_IDLE_TIMEOUT = 1000;
var DEFAULT_FINAL_TIMEOUT = 30000;
var DEFAULT_HEARTBEAT_INTERVAL = 5000;
/**
 * @inheritDoc
 */

var IdleTransactionSpanRecorder = /*#__PURE__*/function (_SpanRecorder) {
  _inherits(IdleTransactionSpanRecorder, _SpanRecorder);

  var _super = _createSuper(IdleTransactionSpanRecorder);

  function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
    var _this;

    _classCallCheck(this, IdleTransactionSpanRecorder);

    _this = _super.call(this, maxlen);
    _this._pushActivity = _pushActivity;
    _this._popActivity = _popActivity;
    _this.transactionSpanId = transactionSpanId;
    ;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(IdleTransactionSpanRecorder, [{
    key: "add",
    value: function add(span) {
      var _this2 = this;

      // We should make sure we do not push and pop activities for
      // the transaction that this span recorder belongs to.
      if (span.spanId !== this.transactionSpanId) {
        // We patch span.finish() to pop an activity after setting an endTimestamp.
        span.finish = function (endTimestamp) {
          span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : timestampWithMs();

          _this2._popActivity(span.spanId);
        }; // We should only push new activities if the span does not have an end timestamp.


        if (span.endTimestamp === undefined) {
          this._pushActivity(span.spanId);
        }
      }

      _get(_getPrototypeOf(IdleTransactionSpanRecorder.prototype), "add", this).call(this, span);
    }
  }]);

  return IdleTransactionSpanRecorder;
}(SpanRecorder);
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */


var IdleTransaction = /*#__PURE__*/function (_Transaction) {
  _inherits(IdleTransaction, _Transaction);

  var _super2 = _createSuper(IdleTransaction);

  /**
   * Timer that tracks Transaction idleTimeout
   */
  function IdleTransaction(transactionContext, _idleHub) {
    var _this3;

    var _idleTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_IDLE_TIMEOUT;

    var _finalTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_FINAL_TIMEOUT;

    var _heartbeatInterval = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_HEARTBEAT_INTERVAL;

    var _onScope = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    _classCallCheck(this, IdleTransaction);

    _this3 = _super2.call(this, transactionContext, _idleHub);
    _this3._idleHub = _idleHub;
    _this3._idleTimeout = _idleTimeout;
    _this3._finalTimeout = _finalTimeout;
    _this3._heartbeatInterval = _heartbeatInterval;
    _this3._onScope = _onScope;

    IdleTransaction.prototype.__init.call(_assertThisInitialized(_this3));

    IdleTransaction.prototype.__init2.call(_assertThisInitialized(_this3));

    IdleTransaction.prototype.__init3.call(_assertThisInitialized(_this3));

    IdleTransaction.prototype.__init4.call(_assertThisInitialized(_this3));

    ;

    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub); // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("Setting idle transaction on scope. Span ID: ".concat(_this3.spanId));

      _idleHub.configureScope(function (scope) {
        return scope.setSpan(_assertThisInitialized(_this3));
      });
    }

    _this3._startIdleTimeout();

    setTimeout(function () {
      if (!_this3._finished) {
        _this3.setStatus('deadline_exceeded');

        _this3.finish();
      }
    }, _this3._finalTimeout);
    return _this3;
  }
  /** {@inheritDoc} */


  _createClass(IdleTransaction, [{
    key: "__init",
    value: // Activities store a list of active spans
    function __init() {
      this.activities = {};
    } // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.

  }, {
    key: "__init2",
    value: function __init2() {
      this._heartbeatCounter = 0;
    } // We should not use heartbeat if we finished a transaction

  }, {
    key: "__init3",
    value: function __init3() {
      this._finished = false;
    }
  }, {
    key: "__init4",
    value: function __init4() {
      this._beforeFinishCallbacks = [];
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this4 = this;

      var endTimestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : timestampWithMs();
      this._finished = true;
      this.activities = {};

      if (this.spanRecorder) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

        var _iterator = _createForOfIteratorHelper(this._beforeFinishCallbacks),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var callback = _step.value;
            callback(this, endTimestamp);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
          // If we are dealing with the transaction itself, we just return it
          if (span.spanId === _this4.spanId) {
            return true;
          } // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early


          if (!span.endTimestamp) {
            span.endTimestamp = endTimestamp;
            span.setStatus('cancelled');
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
          }

          var keepSpan = span.startTimestamp < endTimestamp;

          if (!keepSpan) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
          }

          return keepSpan;
        });
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] flushing IdleTransaction');
      } else {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] No active IdleTransaction');
      } // if `this._onScope` is `true`, the transaction put itself on the scope when it started


      if (this._onScope) {
        clearActiveTransaction(this._idleHub);
      }

      return _get(_getPrototypeOf(IdleTransaction.prototype), "finish", this).call(this, endTimestamp);
    }
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */

  }, {
    key: "registerBeforeFinishCallback",
    value: function registerBeforeFinishCallback(callback) {
      this._beforeFinishCallbacks.push(callback);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "initSpanRecorder",
    value: function initSpanRecorder(maxlen) {
      var _this5 = this;

      if (!this.spanRecorder) {
        var pushActivity = function pushActivity(id) {
          if (_this5._finished) {
            return;
          }

          _this5._pushActivity(id);
        };

        var popActivity = function popActivity(id) {
          if (_this5._finished) {
            return;
          }

          _this5._popActivity(id);
        };

        this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen); // Start heartbeat so that transactions do not run forever.

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Starting heartbeat');

        this._pingHeartbeat();
      }

      this.spanRecorder.add(this);
    }
    /**
     * Cancels the existing idletimeout, if there is one
     */

  }, {
    key: "_cancelIdleTimeout",
    value: function _cancelIdleTimeout() {
      if (this._idleTimeoutID) {
        clearTimeout(this._idleTimeoutID);
        this._idleTimeoutID = undefined;
      }
    }
    /**
     * Creates an idletimeout
     */

  }, {
    key: "_startIdleTimeout",
    value: function _startIdleTimeout(endTimestamp) {
      var _this6 = this;

      this._cancelIdleTimeout();

      this._idleTimeoutID = setTimeout(function () {
        if (!_this6._finished && Object.keys(_this6.activities).length === 0) {
          _this6.finish(endTimestamp);
        }
      }, this._idleTimeout);
    }
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */

  }, {
    key: "_pushActivity",
    value: function _pushActivity(spanId) {
      this._cancelIdleTimeout();

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("[Tracing] pushActivity: ".concat(spanId));
      this.activities[spanId] = true;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */

  }, {
    key: "_popActivity",
    value: function _popActivity(spanId) {
      if (this.activities[spanId]) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("[Tracing] popActivity ".concat(spanId)); // eslint-disable-next-line @typescript-eslint/no-dynamic-delete

        delete this.activities[spanId];
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
      }

      if (Object.keys(this.activities).length === 0) {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampWithMs is in seconds, timeout is in ms
        var endTimestamp = timestampWithMs() + this._idleTimeout / 1000;

        this._startIdleTimeout(endTimestamp);
      }
    }
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */

  }, {
    key: "_beat",
    value: function _beat() {
      // We should not be running heartbeat if the idle transaction is finished.
      if (this._finished) {
        return;
      }

      var heartbeatString = Object.keys(this.activities).join('');

      if (heartbeatString === this._prevHeartbeatString) {
        this._heartbeatCounter += 1;
      } else {
        this._heartbeatCounter = 1;
      }

      this._prevHeartbeatString = heartbeatString;

      if (this._heartbeatCounter >= 3) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] Transaction finished because of no change for 3 heart beats');
        this.setStatus('deadline_exceeded');
        this.finish();
      } else {
        this._pingHeartbeat();
      }
    }
    /**
     * Pings the heartbeat
     */

  }, {
    key: "_pingHeartbeat",
    value: function _pingHeartbeat() {
      var _this7 = this;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("pinging Heartbeat -> current counter: ".concat(this._heartbeatCounter));
      setTimeout(function () {
        _this7._beat();
      }, this._heartbeatInterval);
    }
  }]);

  return IdleTransaction;
}(Transaction);
/**
 * Reset transaction on scope to `undefined`
 */


function clearActiveTransaction(hub) {
  var scope = hub.getScope();

  if (scope) {
    var transaction = scope.getTransaction();

    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}

export { DEFAULT_FINAL_TIMEOUT, DEFAULT_HEARTBEAT_INTERVAL, DEFAULT_IDLE_TIMEOUT, IdleTransaction, IdleTransactionSpanRecorder };